module.exports = __webpack_public_path__ + "static/media/zl_2_9.e8f759be.png";